import * as React from 'react';
interface IBotHeaderProps {
    title?: string;
    subTitle?: string;
    toggleFn: any
    chatbotsettings: any;
}

interface IBotHeaderState {
    setCountValue: any;
    showHeaderCount: boolean;
}


class BotHeader extends React.Component<IBotHeaderProps, IBotHeaderState> {
    state: IBotHeaderState = {
        setCountValue: 0,
        showHeaderCount: false
    };

    toggleChatFn = () => {

        this.props.toggleFn();
    }
    setCountValueFn = (countVal: any) => {
        this.setState({
            setCountValue: countVal,
            showHeaderCount: true
        })
    }

    hideCountValueFn = (countVal: any) => {
        this.setState({
            setCountValue: 0,
            showHeaderCount: false
        })
    }

    render() {
        return (
            <div >
                <div id="webchat-header">
                    <a title="close chat" href="#"
                        className='bot-header-close' onClick={this.toggleChatFn}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.99991 3.58615L3.58569 5.00037L18.9999 20.4146L20.4141 19.0004L4.99991 3.58615Z" fill="#000B48" />
                            <path d="M18.9999 3.58547L3.58569 18.9997L4.99991 20.4139L20.4141 4.99969L18.9999 3.58547Z" fill="#000B48" />
                        </svg>
                    </a>
                    <div className="d-flex  chatbot-header">
                        <div className="d-inline-flex chatbot-logo">
                            <span className="logo-container d-flex">


                            </span>
                        </div>
                        <div className="chatbot-title">

                            <h1 className='bot-title' aria-label='Chat with us' >{this.props.title}</h1>

                            <div className='bot-sub-title'>
                                {this.state.showHeaderCount && (
                                    <span> {this.state.setCountValue}</span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BotHeader;
